export const isValidUrl = (str: string): boolean => {
  try {
    const url = new URL(str);

    return ['http:', 'https:'].includes(url.protocol);
  } catch (error) {
    return false;
  }
};

export const isValidSHA256 = (str: string): boolean => {
  const sha256 = /^([0-9a-fA-F][0-9a-fA-F]:){31}([0-9a-fA-F][0-9a-fA-F])$/;

  return sha256.test(str);
};
